// The defaultLogo is used almost exclusively for SEO metadata so the URL must be a FQDN.
// This is a bandaid, the url is hardcoded to the prod address because other environments
// can't be shared, for example, link unfurls won't work.
export const defaultLogo =
  "https://app.etr.ai/static/images/ETR-meta-background-white.png"

export const lightLogo = "/static/images/ETR_only_white.png"
export const colorLogo = "/static/images/ETR-color-ltrs-logo.png"
export const vennLogo =
  "https://s3.amazonaws.com/dev-etr/images/defaults/VENN+Logo.svg"
export const etrColorInsights = "/static/images/ETR-color-insights-logo.png"
export const etrWhiteInsightsLogo = "/static/images/ETR-white-insights-logo.png"
export const etrInsightsCircleMicIcon =
  "/static/images/ETR-insights-circle-mic-icon.png"
export const etrInsightsCircleCalendarIcon =
  "/static/images/ETR-insights-circle-calendar-icon.png"
export const etrInsightsCircleSearchIcon =
  "/static/images/ETR-insights-cirlce-search-icon.png"
export const productFallbackBackground =
  "/static/images/productFallbackBackground.png"
export const etrInsightsMarketing = "/static/images/ETR-insights-marketing.png"
